import React from "react";
import Header from "./Header/Header";
import WayList from "./Footer/Ways/WayList";
import WayTitle from "./Footer/Ways/WayTitle";
import WaysHeadImage from "./Footer/Ways/WaysHeadImage";
import PlatformText from "./Platform/PlatformText";
import DastresiTxt from "./Platform/DastresiTxt";
import SmartPlatform from "./Platform/SmartPlatform";
import SocialTxt from "./Footer/SocialMedia/SocialTxt"
import SocialImages from "./Footer/SocialMedia/SocialImages"
import MainPic from "./Access/MainPic"
import Menu from "./Access/Menu"
import AccessButton from "./Access/AccessButton"
import "./Home.css";
import PollComponent from "./Poll/PollComponent"
import Acquaintance from "./Acquaintance/Acquaintance.js";

export default function HeaderType(props) {

    function compare(a, b) {
        if (a.Priority < b.Priority) {
            return -1;
        }
        if (a.Priority > b.Priority) {
            return 1;
        }
        return 0;
    }

    return (


        props.Module.sort(compare).map((module) => {
            switch (module.CategoryID) {
                case 1:
                    if (1) {
                        return <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", marginBottom: "-2rem" }}>
                            <Header {...module} />
                        </div>
                    }
                    else break;
                case 2:
                    if (1) {
                        return <div style={{ backgroundColor: module.BackgroundColor, width: "100%" }}>
                            <PlatformText {...module} />
                        </div>
                    }


                    else
                        break;
                case 16:
                    if (1) {
                        return <div style={{ backgroundColor: module.BackgroundColor, width: "100%" }}>
                            <AccessButton {...module} />
                        </div>
                    }
                    else
                        break;
                case 21:
                    if (1) {
                        return <div style={{ backgroundColor: module.BackgroundColor, width: "100%" }}>
                            <SmartPlatform {...module} />
                        </div>

                    }
                    else
                        break;
                case 15:
                    if (1) {

                        return <div style={{ backgroundColor: module.BackgroundColor, width: "100%", margin: "1rem" }}>
                            <DastresiTxt {...module} />
                        </div>

                    }
                    else
                        break;
                case 22:
                    if (1) {
                        return <div style={{ backgroundColor: module.BackgroundColor, width: "100%" }}>
                            <Menu {...module} />
                        </div>
                    }
                    break;
                case 23:
                    if (1) {
                        return <MainPic {...module} />

                    }
                    else
                        break;
                case 6:
                    if (1) {
                        return <WayList {...module} />

                    }
                    else
                        break;
                case 17:
                    if (1) {
                        return <WayTitle {...module} />
                    }
                    else
                        break;
                case 24:
                    if (1) {
                        return <div style={{ backgroundColor: module.BackgroundColor, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <WaysHeadImage {...module} />
                        </div>

                    }
                    else
                        break;
                case 20:
                    if (1) {

                        return <div style={{ backgroundColor: module.BackgroundColor, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <SocialTxt {...module} />
                        </div>
                    }
                    else
                        break;
                case 25:
                    if (1) {

                        return <div style={{ backgroundColor: module.BackgroundColor, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <SocialImages {...module} />
                        </div>

                    }
                    else
                        break;
                case 18:
                    if (1) {

                        return <div style={{ backgroundColor: module.BackgroundColor, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <PollComponent {...module} />
                        </div>

                    }else break
                case 27:
                    if (1) {
                        return <div style={{ backgroundColor: module.BackgroundColor, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Acquaintance {...module} />
                        </div>

                    }else break

                default:
                    break;
            }
        })



    )
}